/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_OfficeInputs */

const cs_nav_office = /** @type {(inputs: Nav_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavení kanceláře`)
};

const en_nav_office = /** @type {(inputs: Nav_OfficeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Office settings`)
};

/**
* | output |
* | --- |
* | "Office settings" |
*
* @param {Nav_OfficeInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_office = /** @type {((inputs?: Nav_OfficeInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_OfficeInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_office(inputs)
	return cs_nav_office(inputs)
});